import exercisesImage from "../assets/images/Exercises.jpg";

export const useSubcategoryImage = (imageUrl?: string | null) => {
  return { image: imageUrl ?? exercisesImage, fallback: exercisesImage };
};
